export default __webpack_public_path__ + "static/media/telegram_logo.0fb9b4f8.png";